import { Component, Input } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';

@Component({
    selector: 'download-extension-control',
    templateUrl: 'download-extension.control.html',
    standalone: false,
})
export class DownloadExtensionControl extends ControlBase {
    @Input()
    public imageWidth: string = '300px';

    public chromeStoreUrl: string;
    public firefoxStoreUrl: string;
}
